<script>
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
export default {
  template: `
    <div class="custom-tooltip box" style="width: 500px">
      <h1>{{title}} - <strong>Prioridad {{getRange()}}</strong></h1>
      <br>
      <div style='margin: 0px !important; width: 100% !important;' v-if='dataGraph && idCanvas'>
        <div class="chart-container" style='position: relative !important; width: 100% !important;'>
          <canvas :id="idCanvas" style="width: 100% !important; height: 65px !important"></canvas>
        </div>
      </div>
    </div>
  `,
  data: function() {
    return {
      dataGraph: null,
      title: "",
      cambio: 0,
      idCanvas: null,
    };
  },
  beforeMount() {
    const params = this.params;
    this.title = params.colDef.headerName;
    this.dataGraph = this.createDataGraphHorizontalBar(
      params.data[params.colDef.field],
      this.title
    );
    this.cambio ? (this.cambio = 0) : (this.cambio = 1);
    this.idCanvas = Math.random()
      .toString(36)
      .substr(2, 9);
  },
  methods: {
    render(_this) {
      // const _this = this;
      Chart.defaults.global.defaultFontFamily = "'Montserrat', sans-serif"; // con esto configuramos el tipo de letra
      Chart.defaults.global.tooltips.backgroundColor = "rgba(45, 64, 89, 0.9)"; // con esto se configura el fondo del tooltip
      Chart.plugins.unregister(ChartDataLabels);

      const ctx = document.getElementById(_this.idCanvas);
      ctx.getContext("2d");

      if (
        _this.dataGraph.type === "horizontalBar" ||
        _this.dataGraph.type === "pie"
      ) {
        _this.dataGraph.plugins = [ChartDataLabels];
      }

      if (_this.chart) {
        // si la grafica ya existia la destruimos
        _this.chart.destroy();
      }

      _this.chart = new Chart(ctx, _this.dataGraph);
    },
    createDataGraphHorizontalBar: function(data, label) {
      if (data && label) {
        const dataHorizontalBar = {
          type: "horizontalBar",
          options: {
            layout: {
              padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
              },
            },
            hover: {
              animationDuration: 0,
            },
            tooltips: {
              enabled: false,
              custom: function(tooltipModel) {
                // Tooltip Element
                let tooltipEl = document.getElementById("chartjs-tooltip");

                // Create element on first render
                if (!tooltipEl) {
                  tooltipEl = document.createElement("div");
                  tooltipEl.id = "chartjs-tooltip";
                  tooltipEl.innerHTML = "<table></table>";
                  tooltipEl.style.backgroundColor = "rgba(0,0,0,0.71)";
                  tooltipEl.style.borderRadius = "5%";
                  document.body.appendChild(tooltipEl);
                }

                // Hide if no tooltip
                if (tooltipModel.opacity === 0) {
                  tooltipEl.style.opacity = 0;
                  return;
                }

                // Set caret Position
                tooltipEl.classList.remove("above", "below", "no-transform");
                if (tooltipModel.yAlign) {
                  tooltipEl.classList.add(tooltipModel.yAlign);
                } else {
                  tooltipEl.classList.add("no-transform");
                }

                function getBody(bodyItem) {
                  return bodyItem.lines;
                }

                // Set Text
                if (tooltipModel.body) {
                  let titleLines = tooltipModel.title || [];
                  let bodyLines = tooltipModel.body.map(getBody);

                  let innerHtml = "<thead>";

                  titleLines.forEach(function(title) {
                    innerHtml +=
                      '<tr><th style="color: white;">' + title + "</th></tr>";
                  });
                  innerHtml += "</thead><tbody>";

                  bodyLines.forEach(function(body, i) {
                    let colors = tooltipModel.labelColors[i];
                    let style = "background:" + colors.backgroundColor;
                    style += "; border-color:" + colors.borderColor;
                    style += "; border-width: 2px";
                    let span = '<span style="' + style + '"></span>';
                    innerHtml +=
                      '<tr><td style="color: white;">' +
                      span +
                      body +
                      "%" +
                      "</td></tr>";
                  });
                  innerHtml += "</tbody>";

                  let tableRoot = tooltipEl.querySelector("table");
                  tableRoot.innerHTML = innerHtml;
                }

                // `this` will be the overall tooltip
                let position = this._chart.canvas.getBoundingClientRect();

                // Display, position, and set styles for font
                tooltipEl.style.opacity = 1;
                tooltipEl.style.position = "absolute";
                tooltipEl.style.left =
                  position.left +
                  window.pageXOffset +
                  tooltipModel.caretX +
                  "px";
                tooltipEl.style.top =
                  position.top +
                  window.pageYOffset +
                  tooltipModel.caretY +
                  "px";
                tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                tooltipEl.style.fontSize = tooltipModel.bodyFontSize + "px";
                tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                tooltipEl.style.padding =
                  tooltipModel.yPadding + "px " + tooltipModel.xPadding + "px";
                tooltipEl.style.pointerEvents = "none";
              },
            },
            scales: {
              xAxes: [
                {
                  ticks: {
                    display: false,
                    beginAtZero: true,
                    max: 100,
                  },
                  scaleLabel: {
                    display: false,
                  },
                  gridLines: {
                    display: false,
                  },
                  stacked: true,
                },
              ],
              yAxes: [
                {
                  gridLines: {
                    display: false,
                  },
                  ticks: {
                    display: false,
                  },
                  stacked: true,
                },
              ],
            },
            legend: {
              position: "top",
              display: false,
            },
            animation: {
              duration: 0,
            },
            pointLabelFontFamily: "Quadon Extra Bold",
            scaleFontFamily: "Quadon Extra Bold",
            responsive: true,
            resizeDelay: 0,
            plugins: {
              datalabels: {
                formatter: function(value, context) {
                  if (value >= 3) return `${value}%`;
                  return "";
                },
                textAlign: "start",
              },
            },
          },
          data: {
            labels: ["Data 1"],
            datasets: [
              {
                label: "Dataset 1",
                data: [28],
                backgroundColor: ["#f4cdcd"],
              },
              {
                label: "Dataset 2",
                data: [45.7],
                backgroundColor: ["#facca5"],
              },
              {
                label: "Dataset 3",
                data: [65.9],
                backgroundColor: ["#fff2cc"],
              },
              {
                label: "Dataset 4",
                data: [72.4],
                backgroundColor: ["#d9ead3"],
              },
              {
                label: "Dataset 5",
                data: [32],
                backgroundColor: ["#c8d9f7"],
              },
            ],
          },
        };

        const sumData = data
          .map((x) => {
            if (x.SubGrupo) return x["countData"]["sum"];
            return 0;
          })
          .reduce((a, b) => a + b, 0);

        let datasets = [];
        // Función que ordena la data a un formato fijo
        const orderData = (p, d) => {
          const postion = (df) => {
            datasets[df] = d;
          };

          switch (p) {
            case "Riesgo muy alto":
              postion(0);
              break;
            case "Riesgo alto":
              postion(1);
              break;
            case "Riesgo medio":
              postion(2);
              break;
            case "Riesgo bajo":
              postion(3);
              break;
            case "Sin riesgo o riesgo despreciable":
              postion(4);
              break;
            case "Sin riesgo o riesgo bajo":
              postion(5);
              break;
            case "Muy alto":
              postion(0);
              break;
            case "Alto":
              postion(1);
              break;
            case "Medio":
              postion(2);
              break;
            case "Bajo":
              postion(3);
              break;
            case "Muy bajo":
              postion(4);
              break;
            default:
              datasets.push(d);
              break;
          }
          /*
          *
          * case 'Insatifacción muy alta':
              postion(0)
              break;
            case 'Insatifacción alta':
              postion(1)
              break;
            case 'Satifacción muy alta':
              postion(2)
              break;
            case 'Satifacción alta':
              postion(3)
              break;
            case 'Satifacción baja':
              postion(4)
              break;
          * */
        };

        data
          .filter((x) => x.SubGrupo)
          .map((x) => {
            const d = {
              label: "Dataset",
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 1,
            };
            const porcentage = this.calculatePorcentage(
              x["countData"]["sum"],
              sumData
            );
            const rango = this.rangoFp(
              x.SubGrupo,
              x.Grupo === "RGO-09-Engagement" ? 1 : 0
            );
            d.data.push(porcentage);
            d.label = x.SubGrupo;
            d.backgroundColor.push(rango.color);
            d.borderColor.push(rango.border);

            orderData(d.label, d);
          });

        dataHorizontalBar.data.labels = [label];
        dataHorizontalBar.data.datasets = datasets.filter((x) => {
          if (x) return true;
        });

        return dataHorizontalBar;
      }
      return this.horizontalBar;
    },
    calculatePorcentage(v, sum) {
      return ((v * 100) / sum).toFixed(1);
    },
    rangoFp: function(p, type = 0) {
      const rangos = {
        rango0: [
          "Riesgo muy alto",
          "Insatisfacción muy alta",
          "Presentación muy alta de sintomas",
          "Muy alto",
        ], // muy alta
        rango1: [
          "Riesgo alto",
          "Insatisfacción alta",
          "Presentación alta de sintomas",
          "Alto",
        ], // alta
        rango2: [
          "Riesgo medio",
          "Satisfacción muy alta",
          "Presentación media de sintomas",
          "Medio",
        ], // medio
        rango3: [
          "Riesgo bajo",
          "Satisfacción alta",
          "Presentación baja de sintomas",
          "Bajo",
        ], // bajo
        rango4: [
          "Sin riesgo o riesgo despreciable",
          "Sin riesgo o riesgo bajo",
          "Satisfacción baja",
          "Presentación muy baja de sintomas o sin presencia de ellos",
          "Muy bajo",
        ], // sin riesgo o muy bajo
      };
      if (rangos.rango0.includes(p)) {
        if (type === 1) {
          return {
            color: "#c8d9f7",
            border: "#a8c2ef",
          };
        }
        return {
          color: "#f4cdcd",
          border: "#f6adad",
        };
      } else if (rangos.rango1.includes(p)) {
        if (type === 1) {
          return {
            color: "#d9ead3",
            border: "#c3eab5",
          };
        }
        return {
          color: "#facca5",
          border: "#f6b884",
        };
      } else if (rangos.rango2.includes(p)) {
        return {
          color: "#fff2cc",
          border: "#f6db8a",
        };
      } else if (rangos.rango3.includes(p)) {
        if (type === 1) {
          return {
            color: "#facca5",
            border: "#f6b884",
          };
        }
        return {
          color: "#d9ead3",
          border: "#c3eab5",
        };
      } else if (rangos.rango4.includes(p)) {
        if (type === 1) {
          return {
            color: "#f4cdcd",
            border: "#f6adad",
          };
        }
        return {
          color: "#c8d9f7",
          border: "#a8c2ef",
        };
      } else {
        return {
          color: "#e1e1e1",
          border: "#c2c0c0",
        };
      }
    },
    getRange() {
      const params = this.params;
      const p = params.data[params.colDef.field];
      if (p) {
        let result = "";
        // Se suma todos los valores
        const sum = p
          .map((x) => {
            if (x.SubGrupo) return x["countData"]["sum"];
            return 0;
          })
          .reduce((a, b) => a + b, 0);

        // Objecto con estructura organizada
        let porcentageGroups = {
          alta1: {
            groups: ["Riesgo alto", "Riesgo muy alto"],
            sum: 0,
          },
          media: {
            groups: ["Riesgo medio", "Riesgo alto", "Riesgo muy alto"],
            sum: 0,
          },
          destacado: {
            groups: [
              "Sin riesgo o riesgo despreciable",
              "Riesgo bajo",
              "Sin riesgo o riesgo bajo",
              "Factor protector",
            ],
            sum: 0,
          },
        };

        // Se saca la suma para la estrucutura solicitada
        p.map((e) => {
          const sub = !e.SubGrupo ? "" : String(e.SubGrupo);

          if (porcentageGroups.alta1["groups"].includes(sub)) {
            porcentageGroups.alta1.sum += parseFloat(
              this.calculatePorcentage(e["countData"]["sum"], sum)
            );
          }
          if (porcentageGroups.media["groups"].includes(sub)) {
            porcentageGroups.media.sum += parseFloat(
              this.calculatePorcentage(e["countData"]["sum"], sum)
            );
          }
          if (porcentageGroups.destacado["groups"].includes(sub)) {
            porcentageGroups.destacado.sum += parseFloat(
              this.calculatePorcentage(e["countData"]["sum"], sum)
            );
          }
        });

        // Se calcula el porcentage para cada elemento del objeto anterior y retornar un rango
        for (const k in porcentageGroups) {
          const porcentage = porcentageGroups[k]["sum"];
          if (k === "alta1" && porcentage >= 30.0) {
            result = "Alta";
            break;
          } else if (k === "media" && porcentage >= 40.0) {
            result = "Media";
            break;
          } else if (k === "destacado" && porcentage >= 60.0) {
            result = "Destacado";
            break;
          } else if (porcentage < 30.0) {
            result = "Sin rango";
          }
        }
        return result;
      }
      return "Sin rango";
    },
  },
  watch: {
    idCanvas() {
      this.render(this);
    },
  },
};
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/frpm/components/tooltipGraphBarHorizontal.vue